import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function Host() {
  return (
    <section data-testid="host-section" className="bg-[#fbf8f0]/90 text-[#16301f]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="lg:col-span-7"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#16301f]/60 flex items-center gap-4">
            <span className="h-px w-12 bg-[#16301f]/40 inline-block" />
            Your Hosts
          </p>
          <h2 className="font-display font-medium text-4xl sm:text-5xl mt-6 leading-[1.08]">
            Hosted, not just listed.
          </h2>
          <p className="font-script text-3xl sm:text-4xl text-[#1a3324] mt-4 -rotate-1 inline-block">
            From our family to yours.
          </p>
          <p className="text-sm sm:text-base leading-relaxed text-[#16301f]/70 font-light mt-8 max-w-xl">
            Every Parker residence is prepared and cared for by our own small team — fresh linens,
            a spotless home, and a real person on the other end of the phone. We host the way we
            would want to be hosted: thoughtfully, quietly, and with pride in every detail.
          </p>
          <p className="text-sm sm:text-base leading-relaxed text-[#16301f]/70 font-light mt-4 max-w-xl">
            Whether you are here for a week of work or a season of life, we are a call or a
            message away — before, during, and after your stay.
          </p>
          <div className="flex flex-wrap gap-4 mt-10">
            <a
              data-testid="host-email-link"
              href="mailto:parkerfurnishedstays@gmail.com"
              className="inline-flex items-center gap-2 bg-[#16301f] text-[#f7f2e7] text-xs uppercase tracking-[0.22em] px-6 py-3.5 hover:bg-[#284b35] transition-colors duration-300"
            >
              <Mail className="w-4 h-4" strokeWidth={1.5} />
              Email Us
            </a>
            <a
              data-testid="host-phone-link"
              href="tel:+12254315052"
              className="inline-flex items-center gap-2 border border-[#16301f]/30 text-[#16301f] text-xs uppercase tracking-[0.22em] px-6 py-3.5 hover:border-[#16301f] transition-colors duration-300"
            >
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              225-431-5052
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
          className="lg:col-span-5"
        >
          <div className="border border-[#16301f]/20 p-3 max-w-sm mx-auto">
            <div className="border border-[#16301f]/10 p-8 bg-[#f7f2e7]">
              <img
                src="/images/logo.png"
                alt="Parker Furnished Stays seal"
                className="w-full h-auto"
              />
            </div>
          </div>
          <p className="text-center text-[10px] uppercase tracking-[0.28em] text-[#16301f]/50 mt-5">
            Parker Furnished Stays · Baker, Louisiana
          </p>
        </motion.div>
      </div>
    </section>
  );
}
